export default "https://cdn-static.gokick.com/assets/90becb6b185a352a9c07d0641a2a2a86ee77cb9a/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";